const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D1DCED",
      strokeWidth: 0.7849,
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "4.1859,4.1859"
    },
    d: " M211.418,146.762c24.873-5.224,48.193-16.419,67.619-32.807c11.936-10.069,24.136-22.499,33.71-37.055 c19.739-30.011,94.219-65.366,176.823-4.06s75.298,109.523,65.132,154.636c-10.166,45.113,0.21,92.217-13.719,129.66 c-11.365,30.551-59.489,120.408-135.699,93.912c-76.209-26.496-65.599-72.319-122.701-110.339 c-57.102-38.02-85.343-1.002-129.615-60.758C133.89,254.203,131.006,163.651,211.418,146.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F8FF"
    },
    d: "M566.992,296.572c-7.095,10.573-16.461,21.12-27.548,32.272 c-30.504,30.614-26.853,96.832-125.648,110.218c-63.395,8.585-92.979-22.27-106.06-45.467 c-13.878-24.638-34.754-46.442-62.051-53.933c-15.24-4.183-56.107,12.46-87.714-25.966 c-41.147-50.06-14.325-150.294,85.311-177.134c90.341-24.304,132.654-183.13,247.267-55.46 C539.297,135.403,651.437,170.729,566.992,296.572z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE7F9"
    },
    d: "M525.642,269.069c0.296-1.108,0.454-2.271,0.454-3.472c0-1.116-0.137-2.199-0.393-3.235 l-2.458,0.273c-0.302-1.255-0.789-2.441-1.433-3.524l1.953-1.561c-0.574-0.991-1.285-1.924-2.134-2.773 c-0.331-0.331-0.675-0.641-1.03-0.93c-0.092-0.078-0.187-0.151-0.282-0.225c-0.404-0.312-0.824-0.598-1.254-0.857l-1.559,1.952 c-0.123-0.076-0.248-0.151-0.374-0.223c-0.141-0.082-0.285-0.161-0.43-0.237c-0.845-0.444-1.745-0.795-2.686-1.042l0.277-2.48 c-1.107-0.296-2.271-0.453-3.47-0.453c-1.115,0-2.199,0.135-3.236,0.393l0.276,2.468c-1.259,0.296-2.446,0.778-3.531,1.415 l-1.555-1.945c-0.992,0.573-1.927,1.284-2.775,2.132c-0.789,0.79-1.458,1.652-2.01,2.566l1.936,1.548 c-0.666,1.072-1.176,2.249-1.503,3.5l-2.464-0.276c-0.296,1.108-0.454,2.271-0.454,3.471c0,1.116,0.137,2.2,0.393,3.236 l2.451-0.274c0.297,1.259,0.783,2.449,1.424,3.536l-1.937,1.548c0.574,0.993,1.286,1.927,2.134,2.775 c0.789,0.789,1.651,1.459,2.566,2.01l1.54-1.925c1.074,0.668,2.251,1.182,3.504,1.51l-0.272,2.446 c1.107,0.296,2.269,0.454,3.471,0.454c1.115,0,2.198-0.136,3.235-0.393l-0.271-2.434c1.264-0.298,2.456-0.784,3.545-1.427 l1.536,1.922c0.991-0.573,1.927-1.284,2.776-2.133c0.789-0.789,1.458-1.651,2.009-2.566l-1.921-1.535 c0.664-1.074,1.173-2.255,1.497-3.511L525.642,269.069z M518.657,265.85c-0.131,4.116-3.483,7.468-7.599,7.599 c-4.543,0.145-8.259-3.569-8.113-8.113c0.131-4.116,3.483-7.468,7.599-7.599C515.088,257.592,518.802,261.306,518.657,265.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE7F9"
    },
    d: "M428.257,402.09c0.463-1.736,0.712-3.558,0.712-5.438c0-1.747-0.215-3.444-0.616-5.067 l-3.851,0.428c-0.473-1.966-1.236-3.823-2.244-5.52l3.059-2.446c-0.899-1.552-2.014-3.014-3.343-4.343 c-0.518-0.518-1.058-1.005-1.613-1.456c-0.144-0.122-0.293-0.237-0.442-0.352c-0.633-0.489-1.29-0.936-1.965-1.343l-2.442,3.057 c-0.193-0.119-0.389-0.236-0.586-0.35c-0.221-0.129-0.446-0.252-0.674-0.371c-1.324-0.696-2.733-1.246-4.207-1.633l0.434-3.884 c-1.734-0.463-3.558-0.71-5.436-0.71c-1.746,0-3.444,0.211-5.069,0.616l0.432,3.866c-1.972,0.464-3.832,1.218-5.53,2.217 l-2.436-3.047c-1.554,0.898-3.018,2.012-4.347,3.339c-1.235,1.238-2.283,2.588-3.148,4.019l3.032,2.424 c-1.044,1.679-1.843,3.523-2.355,5.483l-3.859-0.432c-0.463,1.736-0.711,3.558-0.711,5.436c0,1.748,0.215,3.446,0.616,5.069 l3.839-0.428c0.466,1.973,1.226,3.835,2.231,5.538l-3.034,2.424c0.899,1.556,2.014,3.018,3.343,4.347 c1.235,1.236,2.586,2.285,4.019,3.149l2.412-3.016c1.682,1.046,3.526,1.851,5.489,2.365l-0.426,3.831 c1.734,0.464,3.554,0.712,5.436,0.712c1.746,0,3.443-0.213,5.067-0.616l-0.424-3.812c1.98-0.467,3.847-1.228,5.553-2.234 l2.407,3.01c1.552-0.897,3.018-2.011,4.348-3.34c1.235-1.235,2.283-2.586,3.147-4.019l-3.009-2.405 c1.04-1.683,1.838-3.532,2.346-5.499L428.257,402.09z M417.316,397.049c-0.206,6.447-5.456,11.698-11.903,11.903 c-7.115,0.227-12.937-5.591-12.708-12.708c0.206-6.447,5.456-11.697,11.903-11.902 C411.726,384.114,417.543,389.932,417.316,397.049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE7F9"
    },
    d: "M448.657,417.347c0.206-0.939,0.294-1.919,0.249-2.924c-0.042-0.934-0.198-1.836-0.452-2.693 l-2.048,0.322c-0.301-1.04-0.753-2.014-1.333-2.896l1.576-1.381c-0.518-0.808-1.149-1.563-1.892-2.241 c-0.29-0.264-0.59-0.512-0.897-0.739c-0.08-0.061-0.162-0.12-0.245-0.178c-0.35-0.246-0.712-0.469-1.083-0.67l-1.231,1.693 c-0.106-0.059-0.214-0.117-0.322-0.173c-0.121-0.064-0.244-0.124-0.369-0.182c-0.724-0.34-1.491-0.6-2.288-0.771l0.138-2.087 c-0.938-0.206-1.919-0.293-2.923-0.248c-0.933,0.042-1.836,0.196-2.695,0.452l0.324,2.056c-1.043,0.295-2.019,0.744-2.902,1.319 l-1.376-1.57c-0.809,0.517-1.564,1.148-2.243,1.89c-0.63,0.691-1.158,1.439-1.585,2.224l1.679,1.223 c-0.517,0.923-0.9,1.927-1.126,2.988l-2.073-0.138c-0.206,0.939-0.294,1.919-0.249,2.923c0.042,0.934,0.198,1.837,0.452,2.695 l2.042-0.322c0.297,1.043,0.748,2.02,1.327,2.906l-1.563,1.369c0.518,0.81,1.149,1.565,1.892,2.243 c0.69,0.631,1.438,1.159,2.224,1.586l1.217-1.67c0.924,0.518,1.93,0.904,2.991,1.132l-0.135,2.058 c0.938,0.206,1.917,0.295,2.923,0.249c0.933-0.042,1.835-0.197,2.694-0.452l-0.319-2.027c1.047-0.298,2.027-0.749,2.914-1.329 l1.359,1.551c0.808-0.517,1.565-1.148,2.243-1.891c0.631-0.69,1.158-1.438,1.585-2.224l-1.666-1.212 c0.515-0.925,0.897-1.932,1.121-2.996L448.657,417.347z M442.686,414.917c0.046,3.451-2.633,6.385-6.074,6.65 c-3.798,0.293-7.05-2.675-7.1-6.485c-0.046-3.451,2.633-6.385,6.074-6.65C439.385,408.138,442.635,411.107,442.686,414.917z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M335.597,366.823c0,0-3.721,38.427-2.055,40.692c3.332,4.531,29.02-29.037,29.02-29.037"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M462.579,333.265c0,0,22.219,31.572,21.89,34.365c-0.658,5.586-39.576-10.909-39.576-10.909"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M336.967,190.481c0,0-10.254,11.725-24.764,22.809 c-13.479,10.296-28.519,17.892-28.519,17.892c-11.236-14.71-8.419-35.756,6.291-46.992 C304.685,172.953,325.731,175.771,336.967,190.481z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M293.752,182.56c1.338,1.752,1.003,4.256-0.749,5.594c-1.752,1.338-4.256,1.003-5.594-0.749 c-1.338-1.752-1.003-4.256,0.749-5.594C289.91,180.473,292.414,180.808,293.752,182.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 302.113,
    y: 179.946,
    transform: "matrix(0.7947 -0.607 0.607 0.7947 -60.5346 226.1174)",
    style: {
      fill: "#7EABF2"
    },
    width: 3.766,
    height: 45.199
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M374.269,180.623c0,0,14.708,5.128,32.799,7.596c16.806,2.293,33.635,1.467,33.635,1.467 c2.502-18.341-10.345-35.247-28.686-37.749S376.771,162.282,374.269,180.623z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M407.929,152.387c-0.298,2.184,1.231,4.196,3.415,4.494c2.184,0.298,4.196-1.231,4.494-3.415 c0.298-2.184-1.231-4.196-3.415-4.494C410.239,148.674,408.227,150.203,407.929,152.387z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 386.296,
    y: 172.94,
    transform: "matrix(0.1351 -0.9908 0.9908 0.1351 180.42 556.3442)",
    style: {
      fill: "#7EABF2"
    },
    width: 45.199,
    height: 3.767
  })))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6A93E5",
      strokeWidth: 3.2919,
      strokeMiterlimit: 10
    },
    x1: 357.566,
    y1: 194.247,
    x2: 354.937,
    y2: 184.298
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A93E5"
    },
    d: "M364.143,183.489l-17.65,4.664c-1.327,0.351-2.687-0.441-3.038-1.768l0,0 c-0.351-1.327,0.441-2.687,1.768-3.038l17.65-4.664c1.327-0.351,2.687,0.441,3.038,1.768l0,0 C366.262,181.778,365.47,183.138,364.143,183.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6A93E5",
      strokeWidth: 1.0757,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M490.55,287.809 c-0.363,16.619-4.442,32.284-11.426,46.219"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6A93E5",
      strokeWidth: 1.0757,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M291.945,346.059 c-12.105-17.953-18.972-39.693-18.464-62.987"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6A93E5",
      strokeWidth: 1.0156,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M297.054,342.776 c-11.473-16.97-17.984-37.534-17.504-59.572"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6A93E5",
      strokeWidth: 1.0156,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M484.48,287.677 c-0.335,15.355-4.031,29.848-10.369,42.791"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -89.9472 353.7293)",
    style: {
      fill: "#6A93E5"
    },
    cx: 382.015,
    cy: 285.441,
    rx: 97.226,
    ry: 97.226
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4829 -0.8757 0.8757 0.4829 -52.4108 482.1282)",
    style: {
      fill: "#A6C6F4"
    },
    cx: 382.015,
    cy: 285.441,
    rx: 89.476,
    ry: 89.476
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -89.9473 353.7293)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 382.015,
    cy: 285.441,
    rx: 84.957,
    ry: 84.957
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A5C89"
    },
    d: "M363.769,218.015L363.769,218.015c-1.436,0.33-2.868-0.566-3.198-2.002l-1.377-5.986 c-0.33-1.436,0.566-2.868,2.002-3.198l0,0c1.436-0.33,2.868,0.566,3.198,2.002l1.377,5.986 C366.101,216.253,365.205,217.685,363.769,218.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A5C89"
    },
    d: "M447.412,269.781L447.412,269.781c-0.331-1.436,0.565-2.869,2.001-3.201l5.988-1.381 c1.436-0.331,2.869,0.565,3.2,2.001l0,0c0.331,1.436-0.565,2.869-2.001,3.2l-5.988,1.381 C449.176,272.113,447.743,271.218,447.412,269.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A5C89"
    },
    d: "M395.691,353.449L395.691,353.449c1.436-0.332,2.869,0.563,3.201,1.999l1.383,5.987 c0.332,1.436-0.563,2.869-1.999,3.201l0,0c-1.436,0.332-2.869-0.563-3.201-1.999l-1.384-5.987 C393.36,355.214,394.255,353.781,395.691,353.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A5C89"
    },
    d: "M311.993,301.769L311.993,301.769c0.332,1.435-0.562,2.868-1.997,3.2l-5.983,1.386 c-1.435,0.332-2.868-0.562-3.201-1.997l0,0c-0.332-1.435,0.562-2.868,1.997-3.2l5.983-1.386 C310.228,299.44,311.66,300.334,311.993,301.769z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6BCCE"
    },
    d: "M400.694,216.06L400.694,216.06c-1.016-0.311-1.587-1.387-1.276-2.403l1.297-4.235 c0.311-1.016,1.387-1.587,2.403-1.276l0,0c1.016,0.311,1.587,1.387,1.276,2.403l-1.298,4.235 C402.785,215.8,401.709,216.371,400.694,216.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6BCCE"
    },
    d: "M432.714,235.885L432.714,235.885c-0.724-0.777-0.681-1.994,0.096-2.719l3.24-3.019 c0.777-0.724,1.994-0.681,2.719,0.096l0,0c0.724,0.777,0.681,1.995-0.096,2.719l-3.24,3.019 C434.655,236.705,433.438,236.662,432.714,235.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6BCCE"
    },
    d: "M449.39,306.704L449.39,306.704c0.311-1.016,1.386-1.588,2.402-1.277l4.235,1.296 c1.016,0.311,1.588,1.386,1.277,2.402l0,0c-0.311,1.016-1.386,1.588-2.402,1.277l-4.235-1.295 C449.651,308.795,449.079,307.72,449.39,306.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6BCCE"
    },
    d: "M429.581,338.733L429.581,338.733c0.777-0.724,1.994-0.682,2.719,0.095l3.021,3.239 c0.725,0.777,0.682,1.994-0.095,2.719l0,0c-0.777,0.724-1.994,0.682-2.719-0.095l-3.021-3.239 C428.761,340.675,428.804,339.458,429.581,338.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6BCCE"
    },
    d: "M358.769,355.444L358.769,355.444c1.016,0.31,1.588,1.385,1.278,2.401l-1.293,4.236 c-0.31,1.016-1.385,1.588-2.401,1.278l0,0c-1.016-0.31-1.588-1.385-1.278-2.401l1.293-4.236 C356.678,355.706,357.753,355.134,358.769,355.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6BCCE"
    },
    d: "M326.73,335.65L326.73,335.65c0.725,0.777,0.683,1.994-0.094,2.719l-3.238,3.022 c-0.777,0.725-1.994,0.683-2.719-0.094l0,0c-0.725-0.776-0.683-1.994,0.094-2.719l3.238-3.022 C324.788,334.832,326.005,334.873,326.73,335.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6BCCE"
    },
    d: "M309.986,264.847L309.986,264.847c-0.31,1.016-1.385,1.589-2.401,1.279l-4.237-1.291 c-1.016-0.31-1.589-1.385-1.279-2.401l0,0c0.31-1.016,1.385-1.589,2.401-1.279l4.237,1.291 C309.723,262.756,310.295,263.831,309.986,264.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6BCCE"
    },
    d: "M329.764,232.798L329.764,232.798c-0.776,0.725-1.993,0.684-2.719-0.092l-3.024-3.236 c-0.725-0.776-0.684-1.993,0.092-2.719l0,0c0.776-0.725,1.993-0.684,2.719,0.092l3.024,3.236 C330.582,230.855,330.541,232.073,329.764,232.798z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M379.398,286.784L379.398,286.784c-1.439-0.414-2.269-1.916-1.856-3.355l21.61-75.099 c0.414-1.439,1.916-2.269,3.355-1.856l0,0c1.439,0.414,2.27,1.916,1.856,3.355l-21.61,75.1 C382.339,286.367,380.837,287.198,379.398,286.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M381.788,284.617L381.788,284.617c0.6,1.371-0.026,2.97-1.397,3.569l-58.916,25.676 c-1.371,0.6-2.97-0.026-3.57-1.397l0,0c-0.599-1.371,0.026-2.97,1.398-3.57l58.916-25.676 C379.59,282.62,381.188,283.246,381.788,284.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M385.218,287.33c-0.877,3.048-4.06,4.809-7.108,3.931c-3.048-0.877-4.809-4.059-3.931-7.108 c0.877-3.049,4.06-4.809,7.108-3.932C384.335,281.099,386.095,284.281,385.218,287.33z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E4F9"
    },
    d: "M553.275,130.79c0,0-2.376-6.84-3.215-9.223c0,0,4.814-6.038,8.077-5.785l4.536,11.522"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M550.759,123.394c0,0,2.318-0.767,3.253-3.656c0.935-2.889,4.277-3.375,4.277-3.375 s4.098-7.506,6.151-8.954c3.053-2.154,2.204-4.675,0.206-4.214c-2.209,0.546-16.687,7.517-18.604,8.655 c-1.917,1.139-1.195,3.908-0.2,6.458S549.899,123.122,550.759,123.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E4F9"
    },
    d: "M618.5,161.304c0,0,4.469-5.697,6.02-7.691c0,0,7.682,0.785,9.233,3.666l-7.239,10.046"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M623.36,155.189c0,0,1.898,1.535,4.835,0.759c2.936-0.776,5.152,1.773,5.152,1.773 s8.53-0.611,10.859,0.332c3.462,1.404,5.125-0.674,3.656-2.105c-1.654-1.563-15.346-9.972-17.34-10.969 c-1.995-0.997-3.933,1.108-5.54,3.324C623.375,150.519,623.124,154.318,623.36,155.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M586.921,214.952c0,0,15.587-10.069,41.293-49.142c0,0-2.659-3.915-9.012-6.353 c0,0-4.875,5.659-14.229,13.823c-7.884,6.881-19.602,8.485-29.205,27.543"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M582.106,185.101c0,0-0.416-18.551-20.243-60.912c0,0-4.728,0.215-10.131,4.351 c0,0,2.268,7.117,4.325,19.361c1.734,10.32-3.036,21.143,8.172,39.304"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M573.253,194.887c-0.434,0.222-0.886,0.434-1.356,0.656c-2.615,1.214-5.815,2.393-9.706,3.51 c-7.073,2.03-16.425,3.847-28.613,5.212c-8.82,0.993-19.138,1.746-31.157,2.181l-0.027-22.621c0,0,7.251-9.626,18.721-10.734 c4.184-0.399,11.922,2.172,20.024,2.074c14.121-0.168,31.751,1.684,37.256,4.592C583.03,182.202,585.229,188.815,573.253,194.887 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 542.3577,
    y1: 182.3672,
    x2: 550.9452,
    y2: 200.3228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3F0095"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F0095",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M573.253,194.887c-0.434,0.222-0.886,0.434-1.356,0.656 c-2.615,1.214-5.815,2.393-9.706,3.51c-6.79,1.41-15.175,2.544-25.21,3.049c-2.393-0.94-4.476-1.817-4.911-2.225 c-1.161-1.081-9.972-7.792-9.972-7.792s4.45-3.874,14.183-3.324c9.742,0.558,11.116,2.234,19.563,3.936 C561.765,193.894,568.546,194.639,573.253,194.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M511.872,199.863c0,0,5.622-9.668,19.132-9.677c6.5-0.004,12.745,4.419,20.831,4.954 c14.094,0.932,31.529,4.155,36.786,7.48c8.273,5.232,6.981,24.251-77.82,20.695"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E4F9"
    },
    d: "M478.89,193.03c0,0,14.718-2.465,25.041-10.961c0,0,5.872,4.867,9.861,14.95 c3.174,8.024,0.222,22.936-2.992,26.26c0,0-16.62-0.789-27.146,2.548"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E4F9"
    },
    d: "M431.801,207.878c0,0,6.92,0.405,9.649,8.435c0,0,11.332-4.719,9.412-15.56 c-1.92-10.842-13.539-0.746-13.539-0.746L431.801,207.878z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095334947196871536220000009573520019718147507_",
    gradientUnits: "userSpaceOnUse",
    x1: 521.3923,
    y1: 152.6742,
    x2: 542.6761,
    y2: 152.6742,
    gradientTransform: "matrix(0.2765 -0.961 0.961 0.2765 147.9248 674.3971)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B9EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C7CBF9",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_00000095334947196871536220000009573520019718147507_)"
    },
    d: "M431.801,207.878 c0,0,6.92,0.405,9.649,8.435c0,0,11.332-4.719,9.412-15.56c-1.92-10.842-13.539-0.746-13.539-0.746L431.801,207.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E4F9"
    },
    d: "M404.095,197.445c0,0,3.071,6.824,16.057,12.082c13.432,5.438,22.799-10.528,23.6-16.597 c0.801-6.069-13.825-10.861-13.825-10.861l-18.862,3.19L404.095,197.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E4F9"
    },
    d: "M444.507,217.686c0,0-9.752,10.578-15.174,13.752c-8.797,5.15-30.669,2.24-35.42-0.316 c0,0-0.657,2.92,0.909,4.468c1.566,1.548,18.099,6.275,26.57,7.341c8.472,1.066,13.441,1.063,20.716-3.244"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161631638189867574520000010308166965783193991_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.5048,
    y1: 259.1482,
    x2: 449.1901,
    y2: 259.1482,
    gradientTransform: "matrix(0.961 0.2765 -0.2765 0.961 83.739 -139.2845)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B9EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C7CBF9",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_00000161631638189867574520000010308166965783193991_)"
    },
    d: "M444.507,217.686 c0,0-9.752,10.578-15.174,13.752c-8.797,5.15-30.669,2.24-35.42-0.316c0,0-0.657,2.92,0.909,4.468 c1.566,1.548,18.099,6.275,26.57,7.341c8.472,1.066,13.441,1.063,20.716-3.244"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC401"
    },
    d: "M496.138,232.734c-10.834-0.484-26.189,0.425-29.393,2.152 c-5.593,3.014-10.839,4.007-15.346,0.705c-4.511-3.288-13.666-8.541-14.768-12.794c-0.642-2.497,0.12-5.145,0.12-5.145 c2.143-6.991,6.897-9.223,9.2-17.836c0.939-3.519,6.436-2.742,8.556-4.107c4.734-3.027,10.657-2.713,22.226-3.159 c5.375-0.223,10.675-2.473,14.827-4.849C497.32,194.766,507.651,216.368,496.138,232.734z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000903369645370043480000011785280623101960880_",
    gradientUnits: "userSpaceOnUse",
    x1: 468.8611,
    y1: 191.3678,
    x2: 468.8611,
    y2: 229.9358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E29F1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC401",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000000903369645370043480000011785280623101960880_)"
    },
    d: "M496.138,232.734 c-10.834-0.484-26.189,0.425-29.393,2.152c-5.593,3.014-10.839,4.007-15.346,0.705c-4.511-3.288-13.666-8.541-14.768-12.794 c-0.642-2.497,0.12-5.145,0.12-5.145c2.143-6.991,6.897-9.223,9.2-17.836c0.939-3.519,6.436-2.742,8.556-4.107 c4.734-3.027,10.657-2.713,22.226-3.159c5.375-0.223,10.675-2.473,14.827-4.849C497.32,194.766,507.651,216.368,496.138,232.734z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E4F9"
    },
    d: "M440.542,214.175c5.159-2.388,17.263-3.268,22.528,4.414c5.264,7.682-7.434,11.712-11.425,11.006 C447.654,228.89,434.71,216.875,440.542,214.175z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031918282603139690760000010375290434322677693_",
    gradientUnits: "userSpaceOnUse",
    x1: 453.309,
    y1: 252.4954,
    x2: 450.7311,
    y2: 241.0124,
    gradientTransform: "matrix(0.961 0.2765 -0.2765 0.961 85.1654 -136.7055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B9EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C7CBF9",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_00000031918282603139690760000010375290434322677693_)"
    },
    d: "M440.542,214.175 c5.159-2.388,17.263-3.268,22.528,4.414c5.264,7.682-7.434,11.712-11.425,11.006C447.654,228.89,434.71,216.875,440.542,214.175z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E4F9"
    },
    d: "M445.105,214.76c-10.336-6.044-12.318,19.036-10.295,33.564c0.064,0.46-0.348,0.82-0.751,0.588 c-8.542-4.9-29.046-8.341-37.052-14.637c-1.443-1.135-2.421-5.686-3.942-6.855c-1.727-1.328-5.77,4.612-0.673,10.846 c5.662,6.926,34.32,22.157,46.669,23.769C452.418,263.779,455.709,220.962,445.105,214.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M464.808,194.225c-2.661,1.063-5.154,2.555-7.309,4.451c-7.11,6.25-16.5,5.274-20.743,4.054 c-12.945-3.725-16.763-6.93-20.483-9.917c-3.805,8.24-9.598,8.694-9.598,8.694c-6.585-3.299-7.782-12.92-6.158-19.124 c3.264-12.36,15.177-18.574,27.841-16.774c6.397,0.904,14.442,2.488,24.381,4.557c23.77,4.952,27.906-5.05,27.906-5.05 s-0.004,0.013,0.006,0.031c0.082,0.579,1.132,9.236-11.045,15.096c0.458-0.014,8.314-1.86,12.679-12.066 C484.733,182.093,475.081,190.099,464.808,194.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3F00C3",
      strokeWidth: 0.3627,
      strokeMiterlimit: 10
    },
    d: "M422.764,195.918 c0,0,12.932,13.219,30.128,9.279"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3F00C3",
      strokeWidth: 0.3627,
      strokeMiterlimit: 10
    },
    d: "M404.967,176.41 c0,0,9.424-13.26,23.908-12.75c14.484,0.51,19.01,7.665,41.186,8.559"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M170.025,236.514c0,0-15.249,34.361-23.353,77.49l3.209,0.927c0,0,7.635-42.165,23.903-76.048 L170.025,236.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M142.492,344.285l38.994,6.533c0,0,1.857-8.903,3.166-17.915c0.725-5,1.284-10.036,1.264-13.607 l-39.643-5.878c-0.276-0.041-0.531,0.154-0.565,0.43l-1.479,12.088l-2.166,17.772 C142.028,343.986,142.217,344.239,142.492,344.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A93E5"
    },
    d: "M144.227,325.937c2.277,1.991,12.874,11.048,17.994,11.35c5.156,0.327,19.513-3.573,22.43-4.384 c0.725-5,1.284-10.036,1.264-13.607l-39.643-5.878c-0.276-0.041-0.531,0.154-0.565,0.43L144.227,325.937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20264C"
    },
    d: "M175.416,222.397c0,0-1.537-0.077-3.904,1.019c-2.367,1.096-7.661,3.312-9.36,3.636 c-1.699,0.324-2.723,0.328-4.126,1.062c-1.403,0.734,2.485,7.268,2.485,7.268s8.105-0.475,9.355-1.316 c1.25-0.841,4.372-2.561,5.53-3.552c1.158-0.991,3.084-2.145,3.045-2.967C178.401,226.726,175.416,222.397,175.416,222.397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9203"
    },
    d: "M156.936,269.92c0,0,0.189,1.382-1.787,1.451c-1.977,0.069-14.671-4.125-14.423-5.604 c0.267-1.595,8.891-2.298,9.163-2.255c0.272,0.042,2.471-0.02,2.851,0.137c0.38,0.157,3.148,1.633,3.148,1.633L156.936,269.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E4F9"
    },
    d: "M253.009,189.399c0.077-0.328,0.15-0.666,0.218-1.013c0.006-0.033,0.012-0.066,0.019-0.099 c0.064-0.335,0.124-0.676,0.176-1.024c0.002-0.011,0.004-0.022,0.005-0.034c0.051-0.344,0.095-0.694,0.132-1.046 c0.007-0.065,0.013-0.13,0.02-0.195c0.035-0.353,0.064-0.708,0.082-1.065c0.021-0.523,0-1.005-0.052-1.434 c-0.052-0.387-0.136-0.743-0.251-1.057c-0.22-0.67-0.544-1.193-0.942-1.591c-0.848-0.879-1.988-1.109-2.909-0.732 c-1.769,0.722-4.374,7.001-4.374,7.001c-2.166,2.124-4.259,2.553-4.751,2.627c-0.063,0.01-0.105,0.01-0.105,0.01 c-0.251,0.01-0.492-0.021-0.722-0.073c-0.638-0.167-0.032-2.114,0.816-3.328c0.387-0.555,1.109-2.595,0-2.574 c-0.387,0.021-3.673,4.123-5.075,7.943h-0.011c0,0,0.011,0.011,0,0.042v0.011c-0.356,0.994-0.586,1.957-0.617,2.836 c-0.247,0.841-0.59,1.762-1.032,2.601c-5.179,6.84-16.396,24.958-18.649,29.174c-8.321-1.924-24.135-2.571-29.191-2.31 c-6.865,0.354-13.012,5.9-6.926,11.223c0,0,15.734,1.678,25.376,1.82c0.351,0.004,0.736,0.024,1.141,0.04 c4.759,0.235,13.282,1.223,17.428-2.044c2.03-1.605,6.432-11.012,10.1-20.243c0.015-0.034,0.024-0.046,0.024-0.046 c1.057-2.66,2.049-5.299,2.908-7.735c1.641-4.467,4.384-7.887,4.428-7.941c0.123-0.102,0.237-0.193,0.328-0.259 c0.377-0.283,1.381-0.701,2.606-1.183c2.25-0.889,5.243-1.957,6.436-2.616c0.712-0.398,1.277-0.816,1.695-1.193h0.01 c0,0,0-0.01,0.011-0.01c0-0.01,0.01-0.01,0.021-0.021c0.018-0.026,0.039-0.069,0.058-0.098c0.46-0.703,1.091-2.325,1.568-4.345 C253.006,189.411,253.007,189.405,253.009,189.399z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127043192802802143310000011078373203053814204_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.3851,
    y1: 226.1711,
    x2: 232.9126,
    y2: 226.1711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B9EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C7CBF9",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_00000127043192802802143310000011078373203053814204_)"
    },
    d: "M205.385,237.152 c4.759,0.235,13.282,1.223,17.428-2.044c2.03-1.605,6.432-11.012,10.1-20.243c-0.431,0.9-7.443,15.446-11.495,18.262 c-4.193,2.925-15.532,1.214-15.532,1.214L205.385,237.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M195.529,182.897c0,0-0.683,9.164-10.285,12.067c0,0-0.003,0.805,1.05,0.504 C188.404,194.865,195.682,190.389,195.529,182.897z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE1BD"
    },
    points: "226.569,372.415 221.896,378.151 216.152,372.328 219.953,366.729  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE1BD"
    },
    points: "290.322,397.185 292.703,402.69 289.344,405.783 285.133,406.087 282.045,399.943  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M184.751,195.742c0,0,12.539-5.842,9.243-16.887c-0.11-0.368-1.303-4.783-8.093-1.524 c-3.59,1.723-7.671,2.156-11.622,1.662c-9.322-1.165-18.562-1.71-20.735,10.381l13.516,2.138L184.751,195.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E4F9"
    },
    d: "M158.106,229.405c0,0,6.805,2.805,11.687,1.578c2.818-0.709,4.297-3.186,5.035-5.156 c0.55-1.45,0.701-2.632,0.701-2.632s-0.628-0.074-1.645-0.072c-0.858,0.007-1.567-0.615-1.705-1.43 c-0.019-0.114-0.026-0.218-0.023-0.325c-0.001-1.135-0.051-2.187,1.927-2.34c0.261-0.023,0.567-0.032,0.92-0.018 c1.537,0.058,3.731-0.577,6.205-2.438c0.149-0.121,0.299-0.241,0.432-0.391c0.01-0.002,0.01-0.002,0.01-0.002 c1.094-1.055,2.195-2.948,3.079-5.313c0.883-2.366,1.558-5.215,1.785-8.202l0.025-11.902l-2.703-1.251 c-1.152-1.863-2.684-3.523-4.711-4.846c-12.274-8-25.51,2.847-24.04,12.8c1.025,6.942,3.542,13.24,4.929,18.064 c0.256,0.89,1.309,4.922,2.025,7.717c0.396,1.524-0.192,3.129-1.469,4.045C159.662,227.943,158.777,228.666,158.106,229.405z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132790459308507639050000009879093090916258483_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.4275,
    y1: 220.1201,
    x2: 175.5455,
    y2: 220.1201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B9EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C7CBF9",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_00000132790459308507639050000009879093090916258483_)"
    },
    d: "M169.456,220.573 c0,0,0.01,0.126,0.044,0.321c0.15,0.76,0.695,2.608,2.637,3.245c1.194-0.149,2.361-0.272,3.394-0.372 c0.034-0.303-0.001-0.572-0.001-0.572s-0.628-0.074-1.645-0.072c-0.858,0.007-1.567-0.615-1.705-1.43 c-0.019-0.114-0.026-0.218-0.023-0.325c-0.001-1.135-0.051-2.187,1.927-2.34c-0.901,0.004-4.215-0.157-6.656-2.926 C167.741,216.515,169.078,218.336,169.456,220.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M187.623,190.568c0,0-1.57,0.507-4.182,0.022c-4.352-0.809-13.686-3.226-15.88,2.756l-8.452-6.574 c0,0,2.908-2.405,3.318-2.59c0.411-0.185,2.905-2.209,4.264-2.524c1.359-0.315,6.978-1.132,7.678-1.127 c0.7,0.005,2.627,0.153,4.27,0.735c1.643,0.582,2.356,1.133,3.146,1.692c0.79,0.56,2.992,2.53,2.992,2.53L187.623,190.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M167.561,193.346c0,0-0.771,5.431-3.223,7.84l-9.077,2.431c0,0-2.555-9.793-1.716-14.243 c1.885-9.996,10.202-6.091,10.202-6.091l2.735,3.906L167.561,193.346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E4F9"
    },
    d: "M162.303,205.674c0,0-1.014-4.74-3.962-5.269c-2.949-0.528-3.529,2.615-2.798,5.568 c1.331,5.381,3.506,5.563,3.506,5.563L162.303,205.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9203"
    },
    d: "M225.28,274.935c0,0,3.401,2.767-0.082,8.304c-3.483,5.537-32.381,43.625-44.974,33.204 c0,0-7.474-8.369-3.939-20.631c3.111-10.789,33.676-24.538,39.88-24.192C221.284,271.906,225.28,274.935,225.28,274.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#491B55"
    },
    d: "M234.529,336.012c3.366-7.568,9.166-14.285,14.673-19.786c0.962-0.958,1.909-1.882,2.83-2.769 c0,0-1.469-0.473-4.219-1.185c0,0,0,0-0.012-0.009c-3.271-0.847-8.367-2.011-14.952-3.073c-1.646-0.263-9.517-4.235-17.876-8.644 c-10.861-5.726-22.566-12.178-22.566-12.178l5.026-12.991l20.228-2.538c0,0,45.045,17.807,54.293,29.489 c0,0,2.223,2.487,2.843,6.158c0.312,1.845,0.229,3.991-0.754,6.267l0.024,0.017c-0.605,1.438-1.245,2.798-1.899,4.075 c-1.01,1.931-4.285,6.206-8.65,11.567c-4.531,5.569-10.253,12.305-15.85,18.786c-10.976,12.735-21.451,24.483-21.451,24.483 s-4.023-0.015-7.767-5.803c0,0,8.598-15.387,15.137-29.779C233.905,337.401,234.221,336.701,234.529,336.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M233.588,338.101c-6.539,14.392-15.137,29.779-15.137,29.779c0.588,0.908,1.185,1.677,1.771,2.32 c0.041,0.057,0.081,0.103,0.131,0.147c3.084,3.318,5.866,3.336,5.866,3.336s10.475-11.749,21.451-24.483 c5.596-6.481,11.319-13.217,15.85-18.786c4.365-5.361,7.64-9.637,8.65-11.567c0.654-1.277,1.294-2.637,1.899-4.075l-0.024-0.017 c0.983-2.276,1.066-4.422,0.754-6.267c-0.62-3.67-2.843-6.158-2.843-6.158c-9.249-11.682-54.293-29.489-54.293-29.489 l-20.228,2.538l-5.026,12.991c0,0,11.705,6.453,22.566,12.178c8.359,4.409,16.231,8.381,17.876,8.644 c6.584,1.061,11.68,2.226,14.952,3.073c0.012,0.009,0.012,0.009,0.012,0.009c2.75,0.712,4.219,1.185,4.219,1.185 c-0.921,0.887-1.868,1.811-2.83,2.769c-5.507,5.501-11.307,12.218-14.673,19.786 C234.221,336.701,233.905,337.401,233.588,338.101z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174583202259880134190000005629148474094450847_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.3854,
    y1: 302.9912,
    x2: 247.8011,
    y2: 302.9912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3F0095"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F0095",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174583202259880134190000005629148474094450847_)"
    },
    d: "M214.973,300.547 c8.359,4.409,16.231,8.381,17.876,8.644c6.584,1.061,11.68,2.226,14.952,3.073c-0.565-0.392-19.209-11.137-34.416-18.546 L214.973,300.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M176.393,302.231c0,0,2.921,13.334,18.788,15.044c2.56,0.278,5.049,1.013,7.323,2.23 c8.042,4.293,27.039,14.169,38.876,18.139c3.688,1.243,6.509,4.255,7.576,7.999c2.492,8.72,6.114,20.303,12.984,28.771 c10.279,12.696,20.634,27.913,20.634,27.913s0.92,0.046,2.459-0.32c0.194-0.043,0.397-0.099,0.61-0.156l0.01-0.002 c0.031-0.005,0.06-0.021,0.091-0.026c0.536-0.154,1.129-0.35,1.772-0.618c2.571-1.039,4.198-2.268,4.198-2.268 s-22.808-58.605-27.956-65.848c-13.057-18.345-50.374-39.366-50.374-39.366l-19.915-9.477l-13.531,14.248L176.393,302.231z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152231746596978836580000015766497722760045473_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.9309,
    y1: 326.3244,
    x2: 270.431,
    y2: 385.4494
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3F0095"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F0095",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152231746596978836580000015766497722760045473_)"
    },
    d: "M176.393,302.231 c0,0,2.921,13.334,18.788,15.044c2.56,0.278,5.049,1.013,7.323,2.23c8.042,4.293,27.039,14.169,38.876,18.139 c3.688,1.243,6.509,4.255,7.576,7.999c2.492,8.72,6.114,20.303,12.984,28.771c10.279,12.696,20.634,27.913,20.634,27.913 s0.92,0.046,2.459-0.32c-6.367-8.436-19.266-30.36-24.124-35.266c-5.102-5.151-8.895-22.081-11.13-27.461 c-2.233-5.37-12.465-7.12-20.462-11.272c-7.997-4.152-18.796-12.391-26.896-14.076c-8.111-1.684-8.926-1.8-14.831-5.373 c-5.904-3.562-7.285-10.169-7.285-10.169l-0.364,0.104L176.393,302.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E4F9"
    },
    d: "M161.914,314.545c-0.227-0.191-0.41-0.372-0.56-0.545c-7.215-7.085-18.558-20.916-19.947-33.492 c-0.003-0.021,0.003-0.043,0.002-0.053c-0.005-0.095-0.005-0.158-0.005-0.158c-0.009-1.059-0.025-2.657-0.017-4.43 c0.01-1.762,0.042-3.708,0.127-5.462c0.494-9.627,2.848-23.811,2.848-23.811c5.549-5.879,12.441,1.079,12.542,7.955 c0.024,1.459-0.419,3.857-1.02,6.704c-1.572,7.328-4.277,17.679-3.24,22.997c1.614,4.595,5.914,12.659,9.82,19.708 c0.016,0.029,0.028,0.038,0.028,0.038c1.706,3.076,3.335,5.951,4.634,8.257l0.001,0.001c0,0,1.483,2.693,3.533,3.848 c4.147,0.926,8.615,9.598,8.401,10.094c-0.44,1.019-1.989-0.498-2.325-1.082c-0.737-1.282-2.25-2.665-2.667-2.148 c-1.39,1.732-0.419,5.19-0.167,5.836c1.396,3.605,5.05,7.178,3.955,7.886c-0.594,0.384-3.301-2.465-5.525-5.972 c-1.655-2.608-2.919-5.564-3.868-8.005l0,0c0,0-1.379-3.09-4.699-6.45c-0.567-0.503-1.187-1.077-1.846-1.711 C161.918,314.549,161.916,314.547,161.914,314.545z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081649918132479184730000002219962928854582922_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.6823,
    y1: 281.5521,
    x2: 162.4645,
    y2: 281.5521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B9EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C7CBF9",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_00000081649918132479184730000002219962928854582922_)"
    },
    d: "M150.372,284.422 c2.097,7.079,11.503,18.809,12.092,19.537c-3.906-7.049-8.206-15.114-9.82-19.708c-1.036-5.318,1.668-15.669,3.24-22.997 l-2.647-2.108l-1.388,4.211C151.85,263.356,148.2,277.091,150.372,284.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC401"
    },
    d: "M140.73,265.766c0,0,0.408-0.345,1.187-0.381c3.18-0.134,13.577,0.208,15.019,4.535 c0,0-0.42-6.504,0.491-13.285c0,0,7.518,40.352,22.459,59.364c-1.054-1.466-4.032-6.413-1.074-12.066 c0.84-1.616,2.16-3.281,4.149-4.943c1.309-1.101,2.905-2.198,4.846-3.268c0.388-0.214,0.774-0.439,1.148-0.671 c14.449-8.751,23.206-28.28,36.24-20.175c-1.638-1.346-28.154-23.217-33.91-35.945c-0.137-0.306-0.27-0.591-0.403-0.876 c7.337,3.256,16.838,4.132,16.838,4.132c0.548-2.722,0.794-5.277,0.867-7.548c0.008-0.139,0.017-0.278,0.014-0.416 c0.003-0.043-0.002-0.074,0.003-0.107c0.115-5.661-0.855-9.452-0.855-9.452s-6.75-0.726-14.448-1.535 c-7.493-0.791-13.405-0.821-16.175-0.777l-0.053-0.002c-0.201,0.002-0.392,0.003-0.56,0.01c-0.719,0.015-1.096,0.037-1.096,0.037 s-0.548,6.169-5.179,7.757c-6.814,2.35-12.211-2.041-12.211-2.041s-10.903,7.272-13.586,15.678 C141.746,252.201,140.73,265.766,140.73,265.766z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042708390214341352690000009388628721787187110_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.0518,
    y1: 235.9101,
    x2: 188.069,
    y2: 299.745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E29F1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC401",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000042708390214341352690000009388628721787187110_)"
    },
    d: "M182.961,298.99 c1.309-1.101,2.905-2.198,4.846-3.268c0.388-0.214,0.774-0.439,1.148-0.671c0.936-5.068,1.913-13.154,1.396-23.491 c-1.153-23.326-11.222-49.026-11.222-49.026l-2.003-0.181l-0.053-0.002c-0.201,0.002-0.392,0.003-0.56,0.01 C177.328,224.237,194.273,263.706,182.961,298.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M216.806,371.382c0,0,0.932,3.161,4.388,4.974c0.495,0.26,1.67-0.326,2.274-0.135 c0.465,0.147,1.01,3.645,1.565,5.863s4.326,7.754,3.589,9.667c-0.752,1.953-3.832-0.737-6.04-2.823 c-2.743-2.592-11.368-9.947-11.838-10.806c-0.426-0.779-0.748-3.841,4.364-6.267 C215.638,371.603,216.107,371.353,216.806,371.382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F00C3"
    },
    d: "M284.717,405.266c0,0,3.131,0.43,6.146-1.81c0.505-0.376,0.732-1.668,1.216-2.208 c0.326-0.364,3.525,0.51,5.776,0.915c2.251,0.405,8.846-0.758,10.287,0.701c1.471,1.489-2.247,3.19-5.056,4.346 c-3.49,1.436-13.739,6.277-14.716,6.352c-0.885,0.068-3.809-0.897-3.92-6.554C284.438,406.422,284.404,405.892,284.717,405.266z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166675111208457851510000006267663225822009786_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.4266,
    y1: 283.2364,
    x2: 179.8859,
    y2: 283.2364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E29F1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC401",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000166675111208457851510000006267663225822009786_)"
    },
    d: "M179.886,315.999 c-1.054-1.466-4.032-6.413-1.074-12.066c-2.41-3.33-2.489-7.967-4.624-12.449c-3.022-6.345-7.145-11.952-9.725-18.328 c-4.719-11.666-6.975-22.681-6.975-22.681l-0.062,6.161C157.427,256.635,164.945,296.986,179.886,315.999z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134972691789564483240000002022517029214851203_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.965,
    y1: 238.0243,
    x2: 208.5871,
    y2: 238.0243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E29F1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC401",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000134972691789564483240000002022517029214851203_)"
    },
    d: "M188.965,233.861 c1.358,2.199,1.917,4.193,1.917,4.193c7.337,3.256,16.838,4.132,16.838,4.132c0.548-2.722,0.794-5.277,0.867-7.548 c-0.005,0.073-0.012,0.147-0.019,0.221c-0.232,2.22-2.364,3.665-4.551,3.221c-3.584-0.727-6.705,0.078-9.627-0.863 C190.931,236.085,189.225,234.146,188.965,233.861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F8DD6"
    },
    d: "M176.568,222.202c0,0,26.221,38.772,11.024,99.447l6.294-1.314c0,0,4.703-31.156,1.339-55.228 c-3.364-24.072-15.014-42.962-15.014-42.962S178.439,221.106,176.568,222.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F8DD6"
    },
    d: "M195.831,320.696c-1.588-0.33-6.07-1.204-9.918-1.395l-4.427,31.515c0,0,5.517,1.278,9.852,1.507 c0.237,0.013,0.441-0.149,0.484-0.382c0.583-3.159,4.405-24.094,4.597-30.497C196.43,321.081,196.186,320.77,195.831,320.696z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171677804324805826950000006844372821225913534_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.1646,
    y1: 205.8727,
    x2: 159.8513,
    y2: 205.8727
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B9EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C7CBF9",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_00000171677804324805826950000006844372821225913534_)"
    },
    d: "M158.279,203.151 c0,0-1.143,0.399-1.114,1.646c0.032,1.354,0.388,3.66,1.572,3.81c0.615,0.078,1.588-1.196,0.849-2.43 c-0.739-1.234-1.593-0.237-1.798-0.467c-0.205-0.231-0.349-1.08-0.147-1.535C157.954,203.47,158.824,203.042,158.279,203.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A7DCE"
    },
    d: "M163.496,336.142c0.315,0.067,0.523,0.358,0.486,0.677c-0.08,0.697-0.236,1.814-0.423,1.951 c-0.275,0.201-5.261-0.672-5.565-0.9c-0.304-0.229-0.244-2.095,0.235-2.529C158.44,335.15,162.069,335.84,163.496,336.142z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EFFC"
    },
    d: "M539.539,257.594c0,0.015,4.95,13.006-3.548,25.328c-8.057,11.366-18.298,9.485-29.07,23.987 c9.033,9.449,18.425,20.974,27.873,31.513c-0.024,0.158,10.336-6.352,22.789-19.309c12.41-13.191,17.423-29.669,15.259-39.634 C562.071,272.023,550.8,263.823,539.539,257.594z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M544.11,266.681c-0.219-0.176-0.3-0.511-0.178-0.785c0.131-0.297,0.451-0.407,0.713-0.247 c8.181,5.017,16.325,10.726,24.238,16.049c0.255,0.178,0.355,0.512,0.228,0.763c-0.127,0.251-0.436,0.32-0.69,0.152 c-7.922-5.257-16.072-10.913-24.253-15.892C544.148,266.71,544.128,266.696,544.11,266.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M542.867,272.792c-0.23-0.181-0.304-0.537-0.163-0.815c0.147-0.289,0.471-0.383,0.725-0.209 c8.244,5.649,16.461,11.863,24.451,17.374c0.253,0.185,0.33,0.512,0.188,0.765c-0.142,0.253-0.457,0.323-0.703,0.156 c-8-5.46-16.222-11.632-24.467-17.249C542.887,272.808,542.877,272.8,542.867,272.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M556.744,291.419c-5.344-4.178-10.746-8.565-16.15-12.745c-0.244-0.188-0.309-0.568-0.145-0.848 c0.164-0.28,0.493-0.354,0.737-0.164c5.404,4.197,10.803,8.6,16.143,12.798c0.241,0.189,0.305,0.556,0.143,0.82 C557.311,291.545,556.985,291.608,556.744,291.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M560.905,306.216c-0.013-0.009-0.025-0.019-0.038-0.029 c-7.814-6.621-15.785-14.373-23.733-21.667c-0.228-0.209-0.263-0.593-0.079-0.856c0.184-0.265,0.516-0.299,0.747-0.099 c7.949,7.312,15.916,15.073,23.721,21.698c0.224,0.19,0.258,0.55,0.078,0.805C561.43,306.309,561.127,306.371,560.905,306.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M556.137,314.422c-0.021-0.014-0.04-0.03-0.059-0.048c-7.806-7.367-15.73-15.908-23.597-23.897 c-0.218-0.221-0.235-0.604-0.039-0.856c0.195-0.251,0.532-0.268,0.748-0.056c7.871,7.998,15.793,16.535,23.591,23.884 c0.215,0.203,0.233,0.574,0.039,0.83C556.643,314.512,556.351,314.568,556.137,314.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M538.97,308.856c-0.023-0.018-0.047-0.039-0.068-0.063c-3.991-4.316-7.98-8.682-11.944-12.862 c-0.213-0.224-0.223-0.601-0.024-0.844c0.2-0.243,0.535-0.268,0.746-0.034c3.967,4.181,7.957,8.543,11.949,12.852 c0.214,0.23,0.224,0.618,0.024,0.863C539.472,308.989,539.182,309.021,538.97,308.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M542.607,326.716c-0.029-0.022-0.057-0.047-0.082-0.076 c-7.527-8.611-15.069-17.954-22.476-26.343c-0.203-0.23-0.202-0.595,0.004-0.82c0.204-0.222,0.537-0.222,0.739,0.01 c7.416,8.386,14.962,17.708,22.488,26.279c0.207,0.235,0.205,0.62-0.004,0.863C543.094,326.841,542.813,326.871,542.607,326.716 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M536.777,331.202c-0.022-0.017-0.043-0.037-0.064-0.059 c-7.749-8.389-15.474-17.367-23.008-25.261c-0.209-0.22-0.224-0.572-0.031-0.786c0.193-0.216,0.515-0.218,0.73,0.004 c7.546,7.875,15.277,16.82,23.027,25.163c0.216,0.232,0.231,0.619,0.032,0.862C537.283,331.346,536.991,331.373,536.777,331.202 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EFFC"
    },
    d: "M375.577,98.659c0.179-0.118,1.948,7.465-6.796,13.865c-7.827,5.627-16.003,5.06-24.912,13.228 c7.073,2.369,13.625,6.985,19,13.57c0.082-0.034,6.65-0.597,16.475-3.356c9.558-2.569,19.468-13.539,21.429-21.759 C393.743,106.869,385.082,101.543,375.577,98.659z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M378.215,103.682c-0.167-0.099-0.181-0.29-0.022-0.448c0.172-0.171,0.482-0.238,0.691-0.147 c6.521,2.827,12.504,6.909,17.644,12.074c0.163,0.171,0.142,0.428-0.046,0.583c-0.189,0.156-0.474,0.147-0.638-0.018 c-5.122-5.147-11.086-9.211-17.585-12.021C378.244,103.698,378.228,103.69,378.215,103.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M376.069,107.136c-0.171-0.105-0.178-0.304-0.009-0.458c0.176-0.161,0.477-0.211,0.671-0.109 c6.288,3.285,11.96,7.885,16.69,13.606c0.147,0.188,0.11,0.435-0.076,0.576c-0.187,0.141-0.454,0.111-0.599-0.065 c-4.721-5.699-10.382-10.275-16.653-13.536C376.084,107.145,376.076,107.141,376.069,107.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M384.108,119.274c-3.28-3.53-6.948-6.527-10.904-8.933c-0.178-0.108-0.179-0.315,0.001-0.465 c0.18-0.149,0.472-0.183,0.65-0.074c3.961,2.428,7.633,5.445,10.914,8.994c0.148,0.16,0.118,0.398-0.065,0.529 C384.522,119.457,384.256,119.433,384.108,119.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M384.005,129.374c-0.007-0.009-0.013-0.02-0.02-0.03c-3.904-6.558-8.837-11.947-14.459-15.964 c-0.161-0.115-0.143-0.317,0.042-0.452c0.186-0.135,0.465-0.147,0.63-0.035c5.62,4.06,10.545,9.489,14.435,16.084 c0.112,0.189,0.055,0.426-0.123,0.526C384.341,129.6,384.123,129.54,384.005,129.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M379.246,132.755c-0.011-0.015-0.021-0.031-0.03-0.046c-3.799-6.74-8.631-12.257-14.146-16.352 c-0.153-0.113-0.128-0.305,0.056-0.431c0.183-0.125,0.458-0.13,0.61-0.021c5.509,4.145,10.326,9.71,14.103,16.492 c0.104,0.187,0.048,0.41-0.123,0.495C379.558,132.971,379.359,132.908,379.246,132.755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M368.141,126c-0.015-0.012-0.03-0.026-0.043-0.04c-2.446-2.666-5.102-4.98-7.922-6.918 c-0.151-0.104-0.131-0.284,0.046-0.404c0.177-0.121,0.447-0.138,0.596-0.028c2.815,1.965,5.465,4.305,7.903,6.996 c0.131,0.144,0.096,0.341-0.076,0.438C368.491,126.132,368.278,126.109,368.141,126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M368.815,135.533c-0.016-0.018-0.032-0.037-0.046-0.057c-4.03-6.015-8.918-10.778-14.333-14.128 c-0.148-0.092-0.129-0.258,0.046-0.374c0.173-0.115,0.437-0.135,0.584-0.041c5.407,3.407,10.277,8.225,14.282,14.289 c0.11,0.166,0.068,0.359-0.091,0.428C369.117,135.71,368.932,135.657,368.815,135.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3BFE2"
    },
    d: "M364.633,136.427c-0.013-0.013-0.026-0.026-0.037-0.04c-4.444-5.372-9.684-9.434-15.366-12.025 c-0.158-0.072-0.16-0.222-0.003-0.337c0.158-0.115,0.411-0.151,0.573-0.076c5.679,2.642,10.907,6.751,15.332,12.167 c0.123,0.151,0.102,0.335-0.045,0.409C364.952,136.593,364.759,136.547,364.633,136.427z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 455.711,
    y: 83.049,
    transform: "matrix(0.8952 -0.4456 0.4456 0.8952 1.4103 214.8702)",
    style: {
      fill: "#D1DCED"
    },
    width: 3.849,
    height: 42.774
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1DCED"
    },
    d: "M465.442,124.44l2.636,2.257c0.416,0.356,1.055,0.038,1.021-0.508l-0.212-3.464L465.442,124.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1DCED"
    },
    d: "M450.279,84.208c0.597,1.2,0.109,2.658-1.092,3.255c-1.2,0.597-2.658,0.109-3.255-1.092 c-0.598-1.2-0.109-2.658,1.092-3.255C448.224,82.519,449.682,83.008,450.279,84.208z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1DCED"
    },
    d: "M457.373,98.444c-0.43,0-0.905-0.195-1.346-0.72c-0.617-0.735-0.811-2.278-1.057-4.233 c-0.286-2.283-0.611-4.871-1.702-6.474c-0.884-1.299-1.806-2.059-2.667-2.197c-0.654-0.106-1.048,0.181-1.052,0.184 c-0.168,0.129-0.411,0.098-0.54-0.072c-0.129-0.169-0.097-0.41,0.072-0.539c0.026-0.021,0.653-0.492,1.642-0.333 c1.091,0.176,2.16,1.025,3.18,2.524c1.196,1.756,1.532,4.442,1.829,6.811c0.212,1.683,0.411,3.273,0.882,3.834 c0.38,0.451,0.793,0.565,1.164,0.316c0.352-0.233,0.539-0.703,0.393-0.984c-0.097-0.189-0.022-0.421,0.166-0.519 c0.192-0.094,0.422-0.022,0.519,0.165c0.327,0.635,0.035,1.522-0.651,1.979C457.973,98.341,457.685,98.444,457.373,98.444z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1DCED"
    },
    d: "M460.751,106.377c0,0,5.238,6.421,7.931,15.935"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1DCED"
    },
    d: "M457.305,108.091c0,0,1.965,8.05,7.931,15.935"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67F4E3"
    },
    d: "M500.276,389.534c0,0-0.135-16.531,12.36-27.586c0,0,4.493,12.968-10.918,30.004"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67F4E3"
    },
    d: "M503.16,394.369c0,0,14.481,7.975,30.146,2.234c0,0-9.275-10.116-31.588-4.651"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67F4E3"
    },
    d: "M502.105,389.983c0,0,5.843-15.465,21.488-21.261c0,0-0.493,13.715-21.016,24.036"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67F4E3"
    },
    d: "M503.763,392.862c0,0,16.432,1.818,28.701-9.487c0,0-12.443-5.79-30.959,7.806"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 477.694,
    y: 383.62,
    transform: "matrix(0.5123 0.8588 -0.8588 0.5123 581.2063 -230.1599)",
    style: {
      fill: "#7EABF2"
    },
    width: 31.087,
    height: 25.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.582,
    y: 394.346,
    transform: "matrix(0.5123 0.8588 -0.8588 0.5123 593.5367 -230.4231)",
    style: {
      fill: "#6A93E5"
    },
    width: 6.108,
    height: 25.998
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EFFC"
    },
    d: "M520.802,131.473c-0.064-2.024-0.79-3.657-2.159-4.858c-1.345-1.179-3.083-1.709-4.579-1.942 l1.728-3.39l-29.554-10.521l-6.494,30.101l1.837,2.772l17.048,6.069l3.176-0.988l2.358-4.624c1.411-0.23,3.345-0.595,4.859-1.066 C514.843,141.217,521.033,138.681,520.802,131.473z M508.361,140.904c-0.877,0.273-1.933,0.51-2.931,0.704l7.561-14.83 c1.311,0.116,3.016,0.478,4.192,1.514c0.896,0.788,1.354,1.852,1.398,3.253C518.744,136.663,514.958,138.852,508.361,140.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#D7E2F2"
    },
    d: "M515.792,121.284l-13.987,27.434l-3.176,0.988l-17.048-6.069 c0,0,18.77,0.087,28.254-24.473L515.792,121.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M453.331,391.952c0,0.905-0.733,1.638-1.638,1.638c-0.905,0-1.638-0.733-1.638-1.638 c0-0.905,0.733-1.638,1.638-1.638C452.597,390.314,453.331,391.047,453.331,391.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M568.084,247.508c0,0.905-0.733,1.638-1.638,1.638c-0.905,0-1.638-0.733-1.638-1.638 c0-0.905,0.733-1.638,1.638-1.638C567.35,245.87,568.084,246.603,568.084,247.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M528.429,151.622c0,0.905-0.733,1.638-1.638,1.638c-0.905,0-1.638-0.733-1.638-1.638 c0-0.905,0.733-1.638,1.638-1.638C527.696,149.984,528.429,150.717,528.429,151.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M410.534,51.451c0,0.905-0.733,1.638-1.638,1.638c-0.905,0-1.638-0.733-1.638-1.638 c0-0.905,0.733-1.638,1.638-1.638C409.8,49.813,410.534,50.547,410.534,51.451z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#67F4E3"
    },
    cx: 247.668,
    cy: 239.226,
    r: 2.961
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7EABF2"
    },
    cx: 500.276,
    cy: 345.303,
    r: 2.961
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#67F4E3"
    },
    cx: 426.901,
    cy: 116.059,
    r: 2.961
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7EABF2"
    },
    cx: 372.32,
    cy: 424.548,
    r: 2.961
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M215.023,177.307c0,0.905-0.733,1.638-1.638,1.638c-0.905,0-1.638-0.733-1.638-1.638 c0-0.905,0.733-1.638,1.638-1.638C214.29,175.669,215.023,176.402,215.023,177.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M328.886,150.219c0,0.905-0.733,1.638-1.638,1.638c-0.905,0-1.638-0.733-1.638-1.638 c0-0.905,0.733-1.638,1.638-1.638C328.152,148.581,328.886,149.314,328.886,150.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M318.373,381.903c0,0.905-0.733,1.638-1.638,1.638s-1.638-0.733-1.638-1.638 c0-0.905,0.733-1.638,1.638-1.638S318.373,380.999,318.373,381.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67F4E3"
    },
    d: "M527.734,87.718c0,0.905-0.733,1.638-1.638,1.638s-1.638-0.733-1.638-1.638 s0.733-1.638,1.638-1.638S527.734,86.813,527.734,87.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67F4E3"
    },
    d: "M323.042,58.408c0,0.905-0.733,1.638-1.638,1.638c-0.905,0-1.638-0.733-1.638-1.638 s0.733-1.638,1.638-1.638C322.309,56.77,323.042,57.504,323.042,58.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67F4E3"
    },
    d: "M262.138,108.091c0,0.905-0.733,1.638-1.638,1.638s-1.638-0.733-1.638-1.638 s0.733-1.638,1.638-1.638S262.138,107.187,262.138,108.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M549.313,380.74c0,0.905-0.733,1.638-1.638,1.638c-0.905,0-1.638-0.733-1.638-1.638 c0-0.905,0.733-1.638,1.638-1.638C548.58,379.102,549.313,379.836,549.313,380.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EABF2"
    },
    d: "M222.998,110.763c0,0.905-0.733,1.638-1.638,1.638c-0.905,0-1.638-0.733-1.638-1.638 c0-0.905,0.733-1.638,1.638-1.638C222.265,109.125,222.998,109.858,222.998,110.763z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EFFC"
    },
    d: "M321.067,118.481l-25.878,22.776c-1.416,1.777-5.93,0.537-12.638-4.81 c-6.729-5.363-8.944-9.487-7.529-11.264l16.432-30.305L321.067,118.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#D7E2F2"
    },
    d: "M321.067,118.481l-25.878,22.776c-1.416,1.777-5.93,0.537-12.638-4.81 c-6.729-5.363-8.944-9.487-7.529-11.264c5.67,10.466,16.801,12.708,18.26,11.821c1.442-0.867,22.622-22.637,22.622-22.637 L321.067,118.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEC9E5"
    },
    d: "M321.076,118.47c-1.725,2.164-9.751-1.364-17.926-7.88c-8.176-6.517-13.405-13.553-11.68-15.717 s9.751,1.364,17.926,7.881C317.571,109.269,322.8,116.306,321.076,118.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E6FA"
    },
    d: "M319.573,117.273c-1.55,1.944-8.761-1.226-16.107-7.081 c-7.346-5.855-12.044-12.178-10.494-14.122c1.55-1.945,8.761,1.226,16.107,7.081 C316.425,109.006,321.123,115.328,319.573,117.273z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67F4E3"
    },
    d: "M306.643,91.705c0,0-9.558-13.41-7.731-23.081c1.827-9.671,13.516-11.638,16.957-3.463 c3.441,8.174-4.592,18.377-3.136,24.589C314.19,95.962,310.908,99.025,306.643,91.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67F4E3"
    },
    d: "M298.37,105.647c0,0,3.516,2.591,9.301,0.692c4.114-1.35,12.108-10.276,18.971-13.283 c6.863-3.008,14.191,4.547,12.172,12.772c-2.019,8.225-15.089,13.976-25.974,10.433 C312.839,116.261,306.215,113.22,298.37,105.647z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DFE6FE"
    },
    points: "252.707,154.421 255.87,151.702 251.971,150.219  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE6FE"
    },
    d: "M197.941,161.851L197.941,161.851c0.203,1.161,1.309,1.936,2.469,1.733l1.69-0.296 c1.16-0.203,1.937-1.309,1.733-2.47l0,0c-0.204-1.161-1.309-1.936-2.469-1.733l-1.69,0.296 C198.514,159.585,197.738,160.691,197.941,161.851z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.048,
    y: 131.187,
    transform: "matrix(-0.1726 -0.985 0.985 -0.1726 112.0164 407.5506)",
    style: {
      fill: "#D1DCED"
    },
    width: 4.267,
    height: 51.081
  })))), /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    style: {
      fill: "#1D262D"
    },
    d: "M385.105,462.676c-0.433,0.442-0.804,0.931-1.108,1.452l-0.466-0.24 c-0.066-0.298-0.349-0.503-0.658-0.467c-0.331,0.039-0.568,0.339-0.529,0.67c0.039,0.331,0.339,0.568,0.67,0.529 c0.065-0.008,0.127-0.026,0.184-0.053l0.451,0.234c-0.251,0.554-0.433,1.139-0.539,1.744l0.746,0.131 c0.231-1.306,0.85-2.506,1.792-3.472L385.105,462.676z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    style: {
      fill: "#1D262D"
    },
    d: "M390.592,460.373c-0.171,0-0.341,0.007-0.51,0.018l-0.073-0.626 c0.188-0.149,0.296-0.39,0.266-0.645c-0.046-0.394-0.402-0.675-0.795-0.629c-0.394,0.047-0.675,0.402-0.629,0.796 c0.03,0.254,0.189,0.461,0.405,0.564l0.073,0.624c-0.714,0.116-1.403,0.332-2.06,0.646l0.327,0.684 c0.934-0.447,1.941-0.673,2.995-0.673c0.496,0,0.993,0.053,1.475,0.157l0.161-0.741 C391.693,460.432,391.143,460.373,390.592,460.373z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    style: {
      fill: "#1D262D"
    },
    d: "M397.194,462.921c0.331-0.041,0.566-0.342,0.525-0.673 c-0.04-0.331-0.342-0.565-0.672-0.525c-0.31,0.038-0.535,0.304-0.53,0.608l-0.416,0.363c-0.418-0.43-0.89-0.813-1.408-1.139 l-0.403,0.641c1.134,0.715,2.02,1.727,2.563,2.926l0.69-0.313c-0.251-0.555-0.567-1.072-0.942-1.545l0.402-0.352 C397.065,462.926,397.129,462.928,397.194,462.921z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    style: {
      fill: "#1D262D"
    },
    d: "M390.044,470.582c-0.386,0.023-0.774,0.034-1.157,0.034 c-0.88,0-1.732-0.061-2.478-0.179c-0.391-0.063-0.847-0.155-1.271-0.292c1.046,1.86,3.069,3.125,5.389,3.125 c2.855,0,5.262-1.916,5.949-4.504c-0.682,0.449-1.506,0.825-2.459,1.123C392.839,470.257,391.464,470.496,390.044,470.582z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    style: {
      fill: "#1D262D"
    },
    d: "M390.592,461.889c-3.353,0-6.079,2.666-6.079,5.943 c0,0.426,0.046,0.849,0.137,1.262c0.674,0.482,2.706,0.89,5.348,0.73c2.879-0.173,5.297-0.957,6.672-2.158 c-0.005-0.195-0.021-0.391-0.045-0.582C396.244,464.123,393.651,461.889,390.592,461.889z M388.433,468.404 c-1.021,0-1.85-0.83-1.85-1.85c0-1.021,0.829-1.85,1.85-1.85c1.02,0,1.85,0.829,1.85,1.85 C390.282,467.574,389.452,468.404,388.433,468.404z M393.17,467.496c-0.75,0-1.36-0.61-1.36-1.36s0.61-1.36,1.36-1.36 s1.36,0.61,1.36,1.36S393.92,467.496,393.17,467.496z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    style: {
      fill: "#1D262D"
    },
    d: "M406.596,463.757c-0.295-0.116-0.806-0.309-1.383-0.237 c-0.551,0.068-0.844,0.341-0.844,1.007v0.865h2.228v1.718h-2.228v5.454h-1.932v-5.454h-1.34v-1.718h1.34v-0.888 c0-1.681,0.896-2.783,2.568-2.783c0.642,0,1.157,0.122,1.59,0.309V463.757z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    style: {
      fill: "#1D262D"
    },
    d: "M411.298,467.089c-0.177-0.03-0.358-0.047-0.526-0.047 c-0.895,0-1.51,0.548-1.51,1.614v3.907h-1.932v-7.172h1.873v0.785c0.451-0.674,1.14-0.978,2.021-0.978 c0.414,0,0.848,0.128,1.094,0.337L411.298,467.089z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    style: {
      fill: "#1D262D"
    },
    d: "M418.965,468.966c0,0.222-0.015,0.488-0.037,0.651h-5.084 c0.207,1.036,0.933,1.487,1.843,1.487c0.621,0,1.295-0.251,1.814-0.688l1.132,1.243c-0.813,0.747-1.85,1.088-3.057,1.088 c-2.198,0-3.723-1.495-3.723-3.753c0-2.257,1.481-3.797,3.627-3.797C417.544,465.199,418.958,466.731,418.965,468.966z  M413.851,468.301h3.175c-0.177-0.918-0.732-1.436-1.562-1.436C414.554,466.864,414.022,467.412,413.851,468.301z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    style: {
      fill: "#1D262D"
    },
    d: "M426.618,468.966c0,0.222-0.015,0.488-0.037,0.651h-5.084 c0.207,1.036,0.933,1.487,1.843,1.487c0.621,0,1.295-0.251,1.814-0.688l1.132,1.243c-0.815,0.747-1.851,1.088-3.057,1.088 c-2.198,0-3.723-1.495-3.723-3.753c0-2.257,1.48-3.797,3.626-3.797C425.197,465.199,426.611,466.731,426.618,468.966z  M421.504,468.301h3.176c-0.178-0.918-0.733-1.436-1.563-1.436C422.207,466.864,421.674,467.412,421.504,468.301z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    style: {
      fill: "#1D262D"
    },
    d: "M434.964,468.974c0,2.153-1.495,3.775-3.471,3.775 c-0.963,0-1.644-0.378-2.109-0.933v3.708h-1.925v-10.133h1.888v0.792c0.466-0.585,1.154-0.984,2.139-0.984 C433.469,465.199,434.964,466.82,434.964,468.974z M429.287,468.974c0,1.132,0.748,1.976,1.843,1.976 c1.14,0,1.851-0.881,1.851-1.976c0-1.096-0.711-1.977-1.851-1.977C430.035,466.998,429.287,467.841,429.287,468.974z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    style: {
      fill: "#1D262D"
    },
    d: "M438.068,463.046c0,0.695-0.54,1.229-1.235,1.229c-0.696,0-1.23-0.533-1.23-1.229 c0-0.696,0.533-1.244,1.23-1.244C437.527,461.802,438.068,462.349,438.068,463.046z M437.809,472.563h-1.931v-7.172h1.931 V472.563z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    style: {
      fill: "#1D262D"
    },
    d: "M441.032,467.945l2.701-2.554h2.369l-3.479,3.375l3.501,3.797h-2.376l-2.716-2.901 v2.901h-1.932v-10.657h1.932V467.945z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M309.413,472.499v-1.055c-0.527,0.718-1.391,1.23-2.388,1.23c-1.846,0-3.149-1.406-3.149-3.706 c0-2.256,1.289-3.721,3.149-3.721c0.952,0,1.816,0.469,2.388,1.245v-3.765h1.099v9.771H309.413z M309.413,470.58v-3.208 c-0.395-0.615-1.245-1.143-2.124-1.143c-1.421,0-2.27,1.172-2.27,2.739c0,1.567,0.85,2.725,2.27,2.725 C308.168,471.693,309.017,471.195,309.413,470.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M311.932,468.954c0-2.051,1.465-3.706,3.487-3.706c2.138,0,3.398,1.67,3.398,3.794v0.278h-5.728 c0.088,1.333,1.025,2.446,2.549,2.446c0.806,0,1.626-0.322,2.183-0.893l0.527,0.718c-0.703,0.703-1.655,1.084-2.813,1.084 C313.441,472.674,311.932,471.166,311.932,468.954z M315.404,466.156c-1.509,0-2.256,1.274-2.314,2.358h4.644 C317.718,467.46,317.015,466.156,315.404,466.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M319.607,471.561l0.571-0.791c0.469,0.542,1.362,1.011,2.329,1.011c1.084,0,1.67-0.513,1.67-1.216 c0-1.714-4.38-0.659-4.38-3.281c0-1.099,0.952-2.036,2.637-2.036c1.201,0,2.051,0.454,2.622,1.025l-0.513,0.762 c-0.424-0.513-1.201-0.894-2.109-0.894c-0.967,0-1.567,0.483-1.567,1.113c0,1.553,4.379,0.527,4.379,3.281 c0,1.187-0.952,2.139-2.783,2.139C321.306,472.674,320.325,472.323,319.607,471.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M326.477,463.68c0-0.41,0.337-0.747,0.732-0.747c0.41,0,0.747,0.337,0.747,0.747 c0,0.41-0.337,0.732-0.747,0.732C326.814,464.413,326.477,464.091,326.477,463.68z M326.667,472.499v-7.075h1.099v7.075H326.667z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M329.582,474.315l0.557-0.82c0.586,0.703,1.289,0.967,2.3,0.967c1.172,0,2.27-0.571,2.27-2.124 v-1.011c-0.512,0.718-1.376,1.26-2.373,1.26c-1.845,0-3.149-1.377-3.149-3.662c0-2.271,1.289-3.677,3.149-3.677 c0.952,0,1.802,0.469,2.373,1.245v-1.069h1.099v6.87c0,2.344-1.641,3.076-3.369,3.076 C331.237,475.37,330.417,475.135,329.582,474.315z M334.709,470.463v-3.091c-0.381-0.615-1.23-1.143-2.109-1.143 c-1.421,0-2.271,1.128-2.271,2.695c0,1.553,0.849,2.695,2.271,2.695C333.478,471.62,334.328,471.078,334.709,470.463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M342.413,472.499v-4.629c0-1.245-0.629-1.641-1.582-1.641c-0.865,0-1.685,0.527-2.095,1.099v5.171 h-1.099v-7.075h1.099v1.025c0.498-0.586,1.464-1.201,2.519-1.201c1.479,0,2.256,0.747,2.256,2.285v4.966H342.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M344.933,468.954c0-2.051,1.465-3.706,3.486-3.706c2.138,0,3.398,1.67,3.398,3.794v0.278h-5.728 c0.088,1.333,1.025,2.446,2.549,2.446c0.806,0,1.626-0.322,2.183-0.893l0.527,0.718c-0.703,0.703-1.655,1.084-2.813,1.084 C346.442,472.674,344.933,471.166,344.933,468.954z M348.404,466.156c-1.509,0-2.256,1.274-2.314,2.358h4.643 C350.719,467.46,350.015,466.156,348.404,466.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M358.35,472.499v-1.055c-0.527,0.718-1.392,1.23-2.388,1.23c-1.845,0-3.149-1.406-3.149-3.706 c0-2.256,1.289-3.721,3.149-3.721c0.952,0,1.817,0.469,2.388,1.245v-3.765h1.098v9.771H358.35z M358.35,470.58v-3.208 c-0.396-0.615-1.245-1.143-2.124-1.143c-1.421,0-2.271,1.172-2.271,2.739c0,1.567,0.85,2.725,2.271,2.725 C357.105,471.693,357.954,471.195,358.35,470.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M364.692,472.499v-9.771h1.099v3.765c0.572-0.776,1.421-1.245,2.388-1.245 c1.846,0,3.149,1.465,3.149,3.721c0,2.3-1.304,3.706-3.149,3.706c-0.996,0-1.86-0.513-2.388-1.23v1.055H364.692z M367.9,471.693 c1.436,0,2.286-1.157,2.286-2.725c0-1.567-0.85-2.739-2.286-2.739c-0.864,0-1.728,0.527-2.109,1.143v3.208 C366.172,471.195,367.036,471.693,367.9,471.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M372.529,474.271c0.161,0.073,0.425,0.117,0.601,0.117c0.483,0,0.805-0.161,1.055-0.747 l0.468-1.069l-2.959-7.148h1.187l2.358,5.801l2.344-5.801h1.201l-3.545,8.511c-0.425,1.025-1.143,1.421-2.08,1.436 c-0.234,0-0.601-0.044-0.806-0.103L372.529,474.271z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.03ba0ff9cde1813d304697b4b04fbf48.svg";
export { ForwardRef as ReactComponent };